import React from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

/**
 * Intestazione ordinabile per tabelle di elenco negozi/KPI.
 * Click toggla asc↔desc; alla prima attivazione usa `defaultDir` (per default
 * desc sui numerici, asc sui testuali passato dal chiamante).
 *
 * Props:
 *  - col: identificatore colonna (string)
 *  - sort: { col, dir } stato corrente del sort
 *  - onSort: callback(col) invocata al click (responsabile del toggle)
 *  - align: 'left' | 'right' | 'center'
 *  - testIdPrefix: prefisso per data-testid (default 'sort')
 */
export function SortTh({ col, sort, onSort, align = 'left', className = '', testIdPrefix = 'sort', children }) {
  const active = sort.col === col;
  const alignCls = align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : 'justify-start';
  const Icon = !active ? ArrowUpDown : sort.dir === 'asc' ? ArrowUp : ArrowDown;
  return (
    <th className={`${align === 'right' ? 'text-right' : ''} ${className} cursor-pointer select-none hover:bg-slate-50 transition-colors`}>
      <button
        type="button"
        onClick={() => onSort(col)}
        className={`inline-flex items-center gap-1 w-full ${alignCls} text-inherit`}
        data-testid={`${testIdPrefix}-${col}`}
        aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}
      >
        <span>{children}</span>
        <Icon className={`w-3 h-3 ${active ? 'text-slate-900' : 'text-slate-300'} shrink-0`} />
      </button>
    </th>
  );
}

/** Hook wrapper per gestire stato sort + toggle. */
export function useSort(initialCol, initialDir = 'desc') {
  const [sort, setSort] = React.useState({ col: initialCol, dir: initialDir });
  const toggleSort = React.useCallback((col, defaultDir = 'desc') => {
    setSort(prev => prev.col === col
      ? { col, dir: prev.dir === 'asc' ? 'desc' : 'asc' }
      : { col, dir: defaultDir });
  }, []);
  return { sort, toggleSort };
}
